import { useCallback, useRef, useState } from 'react';
import ChatExpert from '@packages/shared/core/common/components/common/Chat/ChatExpert';
import ChatFooter from '@packages/shared/core/common/components/common/Chat/ChatFooter';
import ChatHeader from '@packages/shared/core/common/components/common/Chat/ChatHeader';
import { ChatInputRefProps } from '@packages/shared/core/common/components/common/Chat/ChatInput';
import ChatMessageList from '@packages/shared/core/common/components/common/Chat/ChatMessageList';
import ChatModal from '@packages/shared/core/common/components/common/Chat/ChatModal';
import { ChatScreenProps } from '@packages/shared/core/quiz/entities';

import styles from './ChatScreen.module.scss';

export const ChatScreen = ({
  incomingMessage,
  expert,
  hasChatSessionEverBeen,
  outgoingMessage,
  sendMessage,
  onBack,
  iceBreakingTipSelected,
  onContinue,
}: ChatScreenProps) => {
  const inputRef = useRef<ChatInputRefProps>(null);
  const [chatInputValue, setChatInputValue] = useState('');

  const focusInput = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  const onSendMessage = () => {
    sendMessage({ text: chatInputValue });
    setChatInputValue('');
  };

  const onInputChange = (value: string) => {
    setChatInputValue(value);
  };

  const onSelectIceBreakingTip = (tip: string) => {
    iceBreakingTipSelected(tip);

    setChatInputValue(tip);
    focusInput();
  };

  if (!expert) {
    return null;
  }

  return (
    <>
      <div className={styles.root}>
        <ChatHeader onBack={onBack} expert={expert} />

        <div className={styles.chat}>
          <div className={styles.chatMessageHeader}>
            <ChatExpert expert={expert} className={styles.expert} />
          </div>

          <ChatMessageList
            incomingMessage={incomingMessage}
            outgoingMessage={outgoingMessage}
            expertImage={expert.image}
          />

          <ChatFooter
            ref={inputRef}
            value={chatInputValue}
            onChange={onInputChange}
            onSendMessage={onSendMessage}
            className={styles.chatFooter}
            onSelectIceBreakingTip={onSelectIceBreakingTip}
          />
        </div>
      </div>

      <ChatModal isOpen={hasChatSessionEverBeen} onBack={onBack} onContinue={onContinue} />
    </>
  );
};

export default ChatScreen;
